// eslint-disable-next-line import/prefer-default-export
export const ACTIVITY_EVENT_MESSAGE = {
  DOCUMENT_CREATED: () => `Created document`,
  DOCUMENT_OPENED: () => `Opened document`,
  DOCUMENT_SENT_FOR_REVIEW: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Shared document with ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Shared document with someone`,
  DOCUMENT_SENT_FOR_ESIGN: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Sent document for eSign to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `sent document for eSign`,
  DOCUMENT_REVIEWED: () => `opened document`,
  DOCUMENT_SENT_FOR_ACCEPT: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `sent document for acceptance to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `sent document for acceptance`,

  DOCUMENT_RESENT_FOR_ACCEPT: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Reminder email sent for acceptance to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Reminder email sent for acceptance`,
  DOCUMENT_RESENT_FOR_ESIGN: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Reminder email sent for eSign to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Reminder email sent for eSign`,
  DOCUMENT_RESENT_TO_FILL_BEFORE_ESIGN: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Reminder email sent for fill and eSign to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Reminder email sent for fill and eSign`,
  DOCUMENT_RESENT_TO_FILL_BEFORE_ACCEPT: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Reminder email sent for fill and accept to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Reminder email sent for fill and accept`,
  DOCUMENT_RESENT_INTERNAL_APPROVAL: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Reminder email sent for internal approval to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Reminder email sent for internal approval`,

  DOCUMENT_ACCEPTOR_ACCEPTED: () => `Document accepted`,
  DOCUMENT_ACCEPTOR_REJECTED: () => `Document rejected`,
  DOCUMENT_ESIGN_DECLINED: () => `Declined to sign document`,
  DOCUMENT_ESIGN_ACCEPTED: () => `eSigned document`,
  DOCUMENT_AUTO_ESIGNED: () => `Document auto eSigned`,
  DOCUMENT_DOWNLOADED: () => `Downloaded document`,
  DOCUMENT_FORWARDED: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Forwarded document to ${subjects
          .map(subject => subject.name)
          .join(", ")} `
      : null,

  // Reviewer email
  REVIEWER_EMAIL_BOUNCED: () => `Email sent for document sharing bounced `,

  // Pipeline related event
  DOCUMENT_PIPELINE_ASSIGNED: meta_info =>
    meta_info && meta_info.to_lane
      ? `Moved document to lane, ${meta_info.to_lane.name}`
      : `Document moved to new lane`,
  DOCUMENT_LANE_CHANGED: meta_info =>
    meta_info && meta_info.to_lane
      ? `Moved document to lane, ${meta_info.to_lane.name}`
      : `Document moved to new lane`,
  DOCUMENT_PIPELINE_CHANGED: meta_info =>
    meta_info && meta_info.from_pipeline && meta_info.to_pipeline
      ? `Moved document from ${meta_info.from_pipeline.name} to ${meta_info.to_pipeline.name}`
      : `Document moved to new pipeline`,

  // Esign related event text
  ESIGN_EMAIL_DELIVERED: () => `Received email and document for eSign `,
  ESIGN_EMAIL_BOUNCED: () => `Email with eSign request bounced`,
  ACCEPTANCE_EMAIL_OPENED: () => `Opened email for document acceptance `,
  ESIGN_EMAIL_OPENED: () => `Opened email for eSign request `,
  DOCUMENT_ALL_ESIGN_ACCEPTED: () => `Received all eSignatures `,
  ACCEPTANCE_EMAIL_DELIVERED: () =>
    `Received email and document for acceptance `,
  ACCEPTANCE_EMAIL_BOUNCED: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Email with acceptance  request to ${subjects
          .map(subject => subject.name)
          .join(", ")} bounced `
      : `Email with acceptance request has bounced`,
  DOCUMENT_ALL_ACCEPTOR_ACCEPTED: () => `Received acceptance from everyone `,
  GENERATED_MASTER_LINK: () =>
    `Published a fillable web link for form document`,
  DOCUMENT_FILLED_ACCEPTED_BY_WEB_LINK: () =>
    `Filled and accepted form via web link`,
  DOCUMENT_FILLED_SUBMITTED_BY_WEB_LINK: () =>
    `Filled and submitted form via web link`,

  // Document Approval flows
  DOCUMENT_INTERNALLY_REJECTED: () => `Rejected approval request`,
  DOCUMENT_SENT_INTERNAL_APPROVAL: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Sent document for internal approval to ${subjects
          .map(subject => subject.name)
          .join(", ")} `
      : null,
  DOCUMENT_INTERNALLY_APPROVED: () => `Approved the document`,
  INTERNAL_APPROVAL_EMAIL_OPENED: () =>
    `Opened email for internal approval request`,
  ESIGN_LINK_EXPIRY_EXTENDED: () => `Expiration date extended`,
};
